import React, { useCallback, useContext } from 'react';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import { CommentContext } from '../../CommentContext';
/** A comment edit view we use for most comment presets. As of writing, this is just our CommentBox with some filled in fields. */
var EditView = function (_a) {
    var className = _a.className, canPostComment = _a.canPostComment, onCommentUpdated = _a.onCommentUpdated;
    var _b = useContext(CommentContext), comment = _b.comment, setEditingState = _b.setEditingState;
    var onCloseEditor = useCallback(function () {
        setEditingState('none');
    }, [setEditingState]);
    var onEditDone = useCallback(function (result) {
        setEditingState('none');
        onCommentUpdated && result.comment && onCommentUpdated(result);
    }, [setEditingState, onCommentUpdated]);
    return (React.createElement(CommentBox, { className: className, onPublishSuccess: onEditDone, id: "edit-".concat(comment.commentId), commentableType: comment.typeId, commentableItemId: comment.itemId, editComment: comment, autoFocus: true, onClose: onCloseEditor, canPostComment: canPostComment }));
};
EditView.displayName = 'EditView';
export default EditView;
//# sourceMappingURL=EditView.js.map